import type { FileKind } from 'web';

export const IMAGE_ITERATOR_ID = 'image_iterator';
export const VIDEO_ITERATOR_ID = 'video_iterator';
export const TEXT_ITERATOR_ID = 'text_iterator';
export const PACK_UNPACK_GAP = 40;

export type PackableFileType = 'image' | 'video';

export type PackUnpackItem = { type: 'file'; file: FileKind } | { type: 'text'; text: string };

export const ITERATOR_ID_BY_FILE_TYPE: Record<PackableFileType, string> = {
  image: IMAGE_ITERATOR_ID,
  video: VIDEO_ITERATOR_ID,
};
